module.exports = __webpack_public_path__ + "img/hover_progress_report_educational_services.eac61098.svg";